import StickyBoxContainer from './StickyBoxContainer';

export default StickyBoxContainer;
